<template>
  <div class="app">
    <div class="">
      <div
        id="cache-menu"
        class="cache"
        @click="closeMobileMenu"
      />
      <Sidebar :name="name"/>
      <AppHeader :name="name"/>
      <main class="main">
        <div class="app-body">
          <router-view :key="$route.fullPath"/>
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import AppHeader from '../components/AppHeader';
import Sidebar from '../components/Sidebar';

export default {
  name: 'full',
  components: {
    AppHeader,
    Sidebar,
  },
  computed: {
    name() {
      return this.$route.name;
    },

  },
  methods: {
    closeMobileMenu() {
      const menuExist = document.body.classList.contains('sidebar-mobile-show');
      if (menuExist) {
        document.body.classList.toggle('sidebar-mobile-show');
      }
    },
  },
};
</script>
